import { createClient } from '@supabase/supabase-js';

const supabaseUrl = 'https://gpookywalqjgsvlaacyb.supabase.co';
const supabaseKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Imdwb29reXdhbHFqZ3N2bGFhY3liIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDAzMzQ4ODIsImV4cCI6MjA1NTkxMDg4Mn0.1d2kki_ynOF_U_T0q17LlijTrawvvDUm5eu0EJXRpxk';

export const supabase = createClient(supabaseUrl, supabaseKey);
